<template>
  <modalGeneric
    title="Delete Comment"
    theme="deleteComment"
    v-if="visible"
    @closeModal="close">
    <section class="containerDeleteCommentModalGeneric">
      <p class="containerDeleteCommentModalGeneric__text">Are you sure you want to delete this comment?</p>
      <div class="containerDeleteCommentModalGeneric__buttons">
        <button class="containerDeleteCommentModalGeneric__buttons--cancel" @click="close">Cancel</button>
        <button class="containerDeleteCommentModalGeneric__buttons--confirm" @click="confirm">Delete</button>
      </div>
    </section>
  </modalGeneric>
</template>

<script>
import { onMounted, ref } from 'vue'
import modalGeneric from '../modalGeneric/modalGeneric'
import { deleteComment } from '../../../services'

export default {
  name: 'deleteCommentModalGeneric',
  emits: ['close', 'refresh'],
  components: {
    modalGeneric
  },
  props: {
    itemId: {
      type: String,
      required: true
    },
    commentId: {
      type: Number,
      required: true
    }
  },
  setup (props, { emit }) {
    const visible = ref(true)
    onMounted(() => {
    })

    /**
     * @description Send event to close the modal
     */
    function close () {
      emit('close')
    }

    /**
     * @description Launches an API request to delete a comment.
     */
    function confirm () {
      visible.value = false
      deleteComment(props.itemId, props.commentId).then(() => {
        emit('refresh')
        close()
      })
    }

    return {
      close,
      confirm,
      visible
    }
  }
}
</script>
